import { render } from "./BackLink.vue?vue&type=template&id=c6de2192&lang=pug"
import script from "./BackLink.vue?vue&type=script&setup=true&lang=js"
export * from "./BackLink.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__